/**
 * API service for Domain Management
 */

const API_BASE_URL = 'https://universal-ai-agent-backend.diypa571.workers.dev'

export interface Domain {
  id: number
  domain: string
  is_verified: boolean
  is_active: boolean
  created_at: string
  updated_at: string
  verified_at?: string | null
}

export interface AddDomainRequest {
  domain: string
}

class DomainsService {
  private async getAuthHeaders(): Promise<HeadersInit> {
    const token = localStorage.getItem('token')
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token || ''}`
    }
  }

  async getDomains(): Promise<Domain[]> {
    try {
      const headers = await this.getAuthHeaders()
      const response = await fetch(`${API_BASE_URL}/api/domains`, {
        method: 'GET',
        headers
      })

      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.message || 'Failed to fetch domains')
      }

      const data = await response.json()
      return data.data || []
    } catch (error) {
      console.error('Get domains error:', error)
      throw error
    }
  }

  async addDomain(request: AddDomainRequest): Promise<Domain> {
    try {
      const headers = await this.getAuthHeaders()
      const response = await fetch(`${API_BASE_URL}/api/domains`, {
        method: 'POST',
        headers,
        body: JSON.stringify(request)
      })

      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.message || 'Failed to add domain')
      }

      const data = await response.json()
      return data.data
    } catch (error) {
      console.error('Add domain error:', error)
      throw error
    }
  }

  async deleteDomain(domainId: number): Promise<void> {
    try {
      const headers = await this.getAuthHeaders()
      const response = await fetch(`${API_BASE_URL}/api/domains/${domainId}`, {
        method: 'DELETE',
        headers
      })

      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.message || 'Failed to delete domain')
      }
    } catch (error) {
      console.error('Delete domain error:', error)
      throw error
    }
  }
}

export const domainsService = new DomainsService()

